import React, { useState, useEffect } from "react";
import { useTheme } from "@repo/shared";
import { useParams, useHistory } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import SchoolDataService from "../../services/school/SchoolService";
import LoadingSpinner from '../common/LoadingSpinner';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Container, Card, Spinner } from 'react-bootstrap';

const School = props => {
  const { id } = useParams();
  const history = useHistory();
  const initialSchoolState = SchoolDataService.initialiseNewSchool();
  const [currentSchool, setCurrentSchool] = useState(initialSchoolState);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [updateMode, setUpdateMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const { appTheme } = useTheme();
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    
    document.title = `${appTheme?.appName || ''} - School`;
    const getSchool = id => {
      SchoolDataService.get(id)
        .then(response => {
          setCurrentSchool(response);
          setLoading(false);
        })
        .catch(console.error);
    };

    if (id) {
      getSchool(id);
      setUpdateMode(true);
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentSchool({ ...currentSchool, [name]: value });
  };

  const validate = () => {
    const errorFields = [];

    if (!currentSchool.name) {
      errorFields.push('Name');
    }

    if (errorFields.length) {
      setErrorMessage(`These fields may not be blank: ${errorFields.join(',')}`);
      return false;
    } else {
      setErrorMessage(null);
      return true;
    }
  };


  const addSchool = () => {
    if (validate()) {
      setSaving(true);
      SchoolDataService.create(currentSchool)
        .then(response => {
          console.log(response);
          setMessage("The School was saved successfully!");
          setSaving(false);
          history.goBack();
        })
        .catch(e => {
          console.log(e);
          setSaving(false);
        });
      }
  };

  const updateSchool = () => {
    if (validate()) {
      setSaving(true);
      SchoolDataService.update(currentSchool.id, currentSchool)
        .then(response => {
          console.log(response);
          setMessage("The School was updated successfully!");
          setSaving(false);
          history.push("/schools");
        })
        .catch(e => {
          console.log(e);
          setSaving(false);
        });
      }
  };

  const deleteSchool = () => {
    confirmAlert({
      title: 'Delete School',
      message: `Are you sure you want to delete this school?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            setSaving(true);
            SchoolDataService.remove(currentSchool.id)
            .then(response => {
              console.log(response);
              setSaving(false);
              history.push("/schools");
            })
            .catch(e => {
              console.log(e);
              setSaving(false);
            });
          }
        },
        {
          label: 'No',
          onClick: () => {}
        },
      ]
    });
    
  };

  const renderBody = () => {
    return (
      <>
      <form>
            <div className="form-group">
              <label htmlFor="title">Name *</label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={currentSchool.name}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Address</label>
              <textarea
                type="text"
                className="form-control"
                id="address"
                name="address"
                value={currentSchool.address}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Phone Number</label>
              <input
                type="text"
                className="form-control"
                id="phoneNumber"
                name="phoneNumber"
                value={currentSchool.phoneNumber}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="description">Email Address</label>
              <input
                type="text"
                className="form-control"
                id="emailAddress"
                name="emailAddress"
                value={currentSchool.emailAddress}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex justify-content-between align-items-flex-end gap-3">
              <div className="form-group flex-grow-1">
                <label htmlFor="description">Year Range</label>
                <input
                  type="text"
                  className="form-control"
                  id="yearRange"
                  name="yearRange"
                  value={currentSchool.yearRange}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="kindergarten"
                  name="kindergarten"
                  checked={currentSchool.kindergarten}
                  onChange={(event) => {
                    const {checked} = event.target;
                    setCurrentSchool({ ...currentSchool, kindergarten: checked });
                  }}
                />
                <label className="form-check-label" htmlFor="kindergarten">
                  Kindergarten
                </label>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="description">Parent Info</label>
              <div style={{color: 'var(--primary-dark-color)'}}>Add information for parents, e.g. Days available for this school</div>
              <textarea
                type="text"
                className="form-control"
                id="parentInfo"
                name="parentInfo"
                value={currentSchool.parentInfo}
                onChange={handleInputChange}
              />
            </div>
          </form>
          <div className="buttonRow">
            { updateMode ? 
              <button
                type="submit"
                className="btn btn-primary"
                onClick={updateSchool}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Updating...
                  </>
                ) : (
                  "Update"
                )}
              </button>
              :
              <button
                type="submit"
                className="btn btn-primary"
                onClick={addSchool}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Saving...
                  </>
                ) : (
                  "Add"
                )}
              </button>
            }
            <button
                className="btn btn-secondary"
                onClick={() => history.goBack()}
              >
                Cancel
              </button>
              { 
                updateMode && <button
                className="btn btn-danger"
                onClick={deleteSchool}
                disabled={saving}
                >
                  {saving ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Deleting...
                    </>
                  ) : (
                    "Delete"
                  )}
                </button>
              }
            </div>
          <p>{message}</p>
          <p className="errorText">{errorMessage}</p>
        </>
    )
  }

  return (
    <Container className="my-4">
      {/* MODERNIZED: Page is wrapped in a main Card for a modern look */}
      <Card className="shadow-sm">
        <Card.Body className="p-4">
          <h2 className="mb-4">{updateMode ? "Update School" : "Add School"}</h2>
          {loading ? <div className='loadingSpinner'><LoadingSpinner/></div> : renderBody()}
        </Card.Body>
      </Card>
    </Container>
  );
  
};

export default School;